module.exports = __webpack_public_path__ + "img/TechCavalryArm2_ua.12e6e5f7.webp";